// extracted by mini-css-extract-plugin
module.exports = {"title":"i_It"};